import { API } from "@/lib/api";

/**
 * Download an .xlsx file from the backend, respecting auth cookies + Bearer token.
 * entity: residents | fees | payments | expenses | outstanding | pnl
 */
export async function downloadXlsx(entity) {
  const token = localStorage.getItem("hostel_token");
  const res = await fetch(`${API}/exports/xlsx/${entity}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) throw new Error(`Export failed: ${res.status}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${entity}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
